import { Link } from 'react-router-dom'
import Layout from '../components/Layout'

// Landing when the user closes Stripe Checkout without paying. Nothing to
// undo — no membership was created — just a friendly bounce back.
export default function MembersCanceled() {
  return (
    <Layout>
      <div className="flex flex-col items-center px-5 pb-12 pt-8 text-center">
        <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-[#F3F4F6] text-[32px]">
          👻
        </div>
        <h1 className="font-bricolage text-[22px] font-extrabold text-navy">
          Checkout canceled
        </h1>
        <p className="mt-2 max-w-xs text-[13px] leading-relaxed text-ink-2">
          No worries — nothing was charged. Ghost Members is still available
          whenever you're ready.
        </p>
        <div className="mt-6 flex gap-2">
          <Link to="/account" className="rounded-xl border border-line bg-white px-4 py-3 text-[13px] font-extrabold text-navy">
            Back to account
          </Link>
          <Link to="/order" className="rounded-xl bg-navy px-4 py-3 font-bricolage text-[13px] font-extrabold text-white">
            Book a pickup
          </Link>
        </div>
      </div>
    </Layout>
  )
}
